import { BookOpenText, Flame } from "lucide-react";
import HeartIcon from "./IconComponent/HeartIcon";
import PriorityIcon from "./IconComponent/PriorityIcon";
import SwordsIcon from "./IconComponent/SwordsIcon";
import FailIcon from "./IconComponent/FailIcon";
import GhostIcon from "./IconComponent/GhostIcon";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_FILTER_TOOLTIPS } from "../constants/menuTooltips";

const FILTER_ITEMS = [
  { id: "info", Icon: BookOpenText },
  { id: "favorites", Icon: HeartIcon },
  { id: "priority", Icon: PriorityIcon },
  { id: "success", Icon: SwordsIcon },
  { id: "failures", Icon: FailIcon },
  { id: "neverPlayed", Icon: GhostIcon },
];

export default function MenuFilter({ onFilter = () => {}, visible = true, activeFilter }) {
  if (!visible) return null;

  return (
    <div className="menuFilterContainer">
      {FILTER_ITEMS.map(({ id, Icon }) => (
        <MenuIconTooltip
          key={id}
          tooltip={MENU_FILTER_TOOLTIPS[id]}
          placement="left"
          portal
          className={activeFilter === id ? "filterIcon active" : "filterIcon"}
        >
          <Icon
            size={50}
            color="#39210d"
            strokeWidth={1}
            onClick={() => onFilter(id)}
            aria-label={MENU_FILTER_TOOLTIPS[id]}
            style={{ cursor: "pointer" }}
          />
        </MenuIconTooltip>
      ))}

      <MenuIconTooltip
        tooltip={MENU_FILTER_TOOLTIPS.lastGame}
        placement="left"
        portal
        className={activeFilter === "lastGame" ? "filterIcon active" : "filterIcon"}
      >
        <Flame
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onFilter("lastGame")}
          aria-label="Mots de la dernière partie"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
